import axios from "axios";
import { FETCH_ALL_SUBCATEGORY_API } from "../Constants/Apis";

export const getSubCategorys = async () => {
  try {
    return axios.get(FETCH_ALL_SUBCATEGORY_API);
  } catch (e) {
    return console.log(e);
  }
};

export const createSubCategory = async (payload) => {
  try {
    return axios.post(FETCH_ALL_SUBCATEGORY_API, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateSubCategory = async (id, payload) => {
  try {
    return axios.put(`${FETCH_ALL_SUBCATEGORY_API}/${id}`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const deleteSubCategory = async (id) => {
  try {
    return axios.delete(`${FETCH_ALL_SUBCATEGORY_API}/${id}`);
  } catch (e) {
    return console.log(e);
  }
};

export const getSubCategorysByCategory = async (category) => {
  try {
    return axios.get(`${FETCH_ALL_SUBCATEGORY_API}/category/${category}`);
  } catch (e) {
    return console.log(e);
  }
};

